import axios from "axios";
import { API_URL } from "./index";
import log from "loglevel";

export const ROLES = {
    USER: 1,
    ADMIN: 2,
    READ_ONLY_USER: 3
};
export const ROLES_OPTIONS = [
    {
        value:ROLES.USER,
        label:"User"
    },
    {
        value:ROLES.ADMIN,
        label:"Admin"
    },
    {
        value:ROLES.READ_ONLY_USER,
        label:"Read Only User"
    }
];

export const AUTH_TYPE_SSO="sso";
export const AUTH_TYPE_JWT="jwt";

class UserService {
    auth = (username, password) =>  {
        
        if (password) {
            const url = API_URL.login();
            return axios.post(url,{username,password})
                .then(({data}) => {
                    return {
                        success:true,
                        ...data,
                        expired_in: 120
                    };
                })
                .catch(
                    error => {
                        return {
                        
                            error
                        };
                    }
                );
        } else {
            log.debug("Following the SSO flow", API_URL.loginSSO());
            window.location=API_URL.loginSSO();
        }
    };

    getUserInfo = () => {
        const url =  API_URL.userAccount();
        return axios.get(url).then(response => response.data);
    };

    logoutSSO = () => {
        const url = API_URL.logoutSSO();
        window.location = url;
    };


    getUserById = (id) => {
        const url =  API_URL.user(id);
        return axios.get(url).then(response => response.data);
    };

    getUsers = () => {
        const url = API_URL.user();
        return axios.get(url).then(response => response.data);
    };

    filterUsers = (params) => {
        const url = API_URL.user("filter");
        return axios.get(url, {
            params
        }).then(response => response.data);
    };
    refreshToken = (refreshToken) => {
        const instance = axios.create();
        const url = API_URL.refreshToken();
        return instance.post(url, {}, {
            headers: {
                "Authorization": `Bearer ${refreshToken}`,
                "Accept":  "application/json, application/octet-stream, image/jpeg, image/png, text/plain; application/pdf; "
            }
        }).then(response => response.data);
    };

    save = (user) => {
        const url = API_URL.user();
        return axios.post(url, user).then(response => response.data);
    };

    changePassword = (payload) => {
        const url = API_URL.user("update-password");
        return axios.post(url, payload)
            .then(response => response.data);
    };
}
UserService.ROLES = ROLES;
export default  new UserService();